import React, { useState, useEffect, useContext } from 'react';
import axios from '../api/axiosConfig';
import { AuthContext } from '../context/AuthContext';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import './Dashboard.css'; // Reutilizamos base de Dashboard

const Settings = () => {
  const { user } = useContext(AuthContext);
  const [runtApiKey, setRuntApiKey] = useState('');
  const [runtApiUrl, setRuntApiUrl] = useState('');
  const [showApiKey, setShowApiKey] = useState(false);
  const [testReferencia, setTestReferencia] = useState('');
  const [testResponse, setTestResponse] = useState(null);
  const [testLoading, setTestLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await axios.get('/api/automation/config');
        if (response.data) {
          setRuntApiUrl(response.data.runt_api_url || 'http://26.2.248.216:8051');
          setRuntApiKey(response.data.runt_api_key || '');
        }
      } catch (err) {
        console.error('Error al cargar configuración:', err);
        // Fallback a localStorage si falla la API
        const savedKey = localStorage.getItem('runt_api_key') || '';
        const savedUrl = localStorage.getItem('runt_api_url') || 'http://26.2.248.216:8051';
        setRuntApiKey(savedKey);
        setRuntApiUrl(savedUrl);
      }
    };

    fetchConfig();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    try {
      // Intentar guardar en el servidor si es superadmin
      if (user?.role === 'superadmin') {
        await axios.post('/api/automation/config', {
          runt_api_key: runtApiKey,
          runt_api_url: runtApiUrl
        });
        setMessage('✅ Configuración guardada correctamente en el servidor.');
      } else {
        // Fallback local para otros usuarios
        localStorage.setItem('runt_api_key', runtApiKey);
        localStorage.setItem('runt_api_url', runtApiUrl);
        setMessage('✅ Configuración guardada correctamente localmente.');
      }
    } catch (err) {
      console.error('Error al guardar configuración:', err);
      const errorMsg = err.response?.data?.message || 'Error al guardar la configuración.';
      setError('❌ ' + errorMsg);
    }
  };

  const handleTestQuery = async () => {
    if (!testReferencia) {
      setError('❌ Por favor ingresa una referencia para probar.');
      return;
    }

    setTestLoading(true);
    setTestResponse(null);
    setError('');
    setMessage('');

    try {
      const response = await axios.get('/api/automation/proxy-consulta-runt', {
        params: { 
          referencia: testReferencia,
          apiUrl: runtApiUrl,
          apiKey: runtApiKey
        }
      });
      setTestResponse(response.data);
      setMessage('✅ Consulta de prueba completada.');
    } catch (err) {
      console.error('Error en prueba de consulta:', err);
      const errorMsg = err.response?.data?.mensaje || err.response?.data?.message || 'Error al conectar con la API';
      setError('❌ Error en prueba: ' + errorMsg);
      if (err.response) setTestResponse(err.response.data);
    } finally {
      setTestLoading(false);
    }
  };

  return (
    <div className="app-layout">
      <Sidebar userRole={user?.role} />
      
      <div className="main-content">
        <Navbar title="⚙️ Configuraciones" />

        <div className="page-content">
          <header className="dashboard-header" style={{ marginBottom: '30px' }}>
            <h2 style={{ fontSize: '24px', color: '#1e293b' }}>Ajustes del Sistema</h2>
            <p style={{ color: '#64748b' }}>Configura las credenciales para servicios externos.</p>
          </header>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px', alignItems: 'start' }}>
            <div className="table-section">
              <h3>Integración RUNT</h3>
              <p style={{ fontSize: '14px', color: '#64748b', marginBottom: '20px' }}>
                Configura la URL y la API Key para el procesamiento de pagos automáticos.
              </p>

              <form onSubmit={handleSave}>
                <div className="filter-group" style={{ marginBottom: '20px', flexDirection: 'column', alignItems: 'flex-start' }}>
                  <label style={{ marginBottom: '8px' }}>URL de la API RUNT:</label>
                  <input
                    type="text"
                    className="search-input"
                    value={runtApiUrl}
                    onChange={(e) => setRuntApiUrl(e.target.value)}
                    placeholder="http://..."
                  />
                </div>

                <div className="filter-group" style={{ marginBottom: '20px', flexDirection: 'column', alignItems: 'flex-start' }}>
                  <label style={{ marginBottom: '8px' }}>API Key (x-api-key):</label>
                  <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                    <input
                      type={showApiKey ? "text" : "password"}
                      className="search-input"
                      value={runtApiKey}
                      onChange={(e) => setRuntApiKey(e.target.value)}
                      placeholder="Ingresa tu API Key"
                      style={{ flex: 1 }}
                    />
                    <button 
                      type="button" 
                      className="btn-secondary"
                      onClick={() => setShowApiKey(!showApiKey)}
                      style={{ padding: '8px 12px', minWidth: '80px' }}
                    >
                      {showApiKey ? '🙈 Ocultar' : '👁️ Ver'}
                    </button>
                  </div>
                </div>

                {message && !testResponse && (
                  <div style={{ padding: '10px', backgroundColor: '#dcfce7', color: '#166534', borderRadius: '6px', marginBottom: '20px', fontSize: '14px' }}>
                    {message}
                  </div>
                )}

                {error && (
                  <div style={{ padding: '10px', backgroundColor: '#fee2e2', color: '#b91c1c', borderRadius: '6px', marginBottom: '20px', fontSize: '14px' }}>
                    {error}
                  </div>
                )}

                <button type="submit" className="btn-primary">
                  💾 Guardar Configuración
                </button>
              </form>
            </div>

            <div className="table-section">
              <h3>Prueba de Consulta</h3>
              <p style={{ fontSize: '14px', color: '#64748b', marginBottom: '20px' }}>
                Verifica la conexión con la API realizando una consulta de referencia rápida.
              </p>

              <div className="filter-group" style={{ marginBottom: '20px', flexDirection: 'column', alignItems: 'flex-start' }}>
                <label style={{ marginBottom: '8px' }}>Referencia de Prueba:</label>
                <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                  <input
                    type="text"
                    className="search-input"
                    value={testReferencia}
                    onChange={(e) => setTestReferencia(e.target.value)}
                    placeholder="Ej: 167088030"
                  />
                  <button 
                    type="button" 
                    className="btn-secondary" 
                    style={{ whiteSpace: 'nowrap' }}
                    onClick={handleTestQuery}
                    disabled={testLoading}
                  >
                    {testLoading ? '⏳ Probando...' : '🔍 Consultar'}
                  </button>
                </div>
              </div>

              {testResponse && (
                <div style={{ marginTop: '20px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', fontWeight: 'bold', color: '#1e293b' }}>Respuesta de la API:</label>
                  <pre style={{ 
                    backgroundColor: '#1e293b', 
                    color: '#f8fafc', 
                    padding: '15px', 
                    borderRadius: '8px', 
                    fontSize: '12px', 
                    overflowX: 'auto',
                    maxHeight: '300px'
                  }}>
                    {JSON.stringify(testResponse, null, 2)}
                  </pre>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
